import { ClientToContactView } from 'app/modules/clients/models/clients.types';

export interface ClientContactAssociation {
    id: number;
    clientId: number;
    contactId: number;
    apRep?: boolean;
    emailContact?: boolean;
    managementRep?: boolean;
    mmrId?: number;
    userId?: number | null;
    userRequested?: boolean;
}

export interface ClientContactFormModel extends Partial<ClientContactAssociation> {
    tempContactId?: number;
}

export function toClientContactAssociation(row: ClientToContactView): ClientContactAssociation {
    return {
        id: row?.id,
        clientId: row?.clientId,
        contactId: row?.contactId,
        apRep: row?.apRep,
        emailContact: row?.emailContact,
        managementRep: row?.managementRep,
        userId: row?.userId,
        userRequested: row?.userRequested
    };
}
